<template>
  <div class="btn-toolbar flex-wrap justify-content-end">
    <div class="btn-group">
      <span @click.prevent="editUserEvent">
        <router-link v-if="$can('update', user)" :to="{ name: 'EditUser', params: { entity_id: entityId, user_id: user.id }}" class="btn btn-icon">
          <i class="fa fa-edit"></i>
        </router-link>
      </span>
      <a v-if="$can('activate', user)" class="btn btn-default" @click.prevent="activateUser">
        <i class="fa fa-check activate-user"></i>
      </a>
      <a v-if="$can('refuse', user)" class="btn btn-danger" @click.prevent="refuseUser">
        <i class="fa fa-ban"></i>
      </a>
      <a v-if="$can('wait', user)" v-tooltip="$t('users.waiting_validation')">
        <i class="pg-clock"></i>
      </a>

      <span v-if="$can('recall', user)" v-tooltip="ableToRemindActive ? $t('users.relaunch') : $t('users.already_relaunch')">
        <span v-if="ableToRemindActive">
          <a class="btn btn-icon" @click.prevent="recallUser">
            <i class="fa fa-refresh" :class="{ 'fa-spin': recallingUser }"></i>
         </a>
        </span>
        <span v-else>
          <button class="btn btn-icon" disabled>
            <i class="fa fa-refresh"></i>
          </button>
        </span>
      </span>

      <delete-user v-if="$can('delete', user)" :user=user :isManager="isManager" :entityId="entityId"></delete-user>
    </div>
  </div>
</template>

<script>
  import DeleteUser from '@/components/users/DeleteUser'
  import { checkRoleCandidate, checkRoleManager, checkRoleAdmin } from '@/helpers/roles'
  import AtInternetManagingCandidate from '@/helpers/at_internet/managing_candidate'
  import AtInternetManagingManager from '@/helpers/at_internet/managing_manager'
  import { mapGetters } from "vuex";

  export default {
    name: 'UserActions',
    props: ['user', 'isManager', 'entityId'],
    data() {
      return {
        recallingUser: false
      }
    },
    components: {
      DeleteUser
    },
    methods: {
      activateUser() {
        AtInternetManagingCandidate.sendValidateCandidatEvent()
        const payload = {
          user: this.user,
          entityId: this.entityId,
          action: 'activate'
        }
        this.$store.dispatch('users/handleMultiAction', payload)
      },
      refuseUser: function(dialog) {
        AtInternetManagingCandidate.sendRefuseCandidatEvent()
        if (this.isSingleEntity) {
          this.$dialog.confirm(this.$i18n.t('users.messages.refuse_member'))
          .then(() => {
            this.$store.dispatch('users/deleteUser', { user: this.user, entityId: this.entityId, entityIds: [this.entityId] })
          })
          .catch(() => {})
        } else {
          this.$store.dispatch('users/getEntitiesForMultiAction', { user: this.user , entityId: this.entityId, action: 'refuse' });
        }
      },
      recallUser() {
        AtInternetManagingCandidate.sendReCallCandidatEvent()
        this.recallingUser = true;
        let self = this;
        this.$store.dispatch('users/recallUser', { user: this.user, entityId: this.entityId }).finally(() => {
          this.recallingUser = false
          self.user.able_to_remind_active = false
        });
      },
      editUserEvent(){
        if(checkRoleCandidate(this.user.role)) {
          this.user.state === "pending" ? 
            AtInternetManagingCandidate.sendEditCandidatEvent() : 
            AtInternetManagingCandidate.sendEditMemberEvent()
        }
        if(checkRoleManager(this.user.role)) {
          AtInternetManagingManager.sendEditManagerEvent();
        }
      }
    },
    computed: {
      ...mapGetters({
        isSingleEntity: 'auth/isSingleEntity'
      }),
      ableToRemindActive() {
        return this.user.able_to_remind_active
      }
    }
  }
</script>

<style type="text/css">
  .btn-icon-dark .fa-ban {
    color: #fff;
  }

  .activate-user {
    color: green;
  }
</style>



// WEBPACK FOOTER //
// src/components/users/UserActions.vue